/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getLandOwnerList = (payload, callback) =>
  req.list(
    c.GET_LAND_OWNER,
    'api/v1/rpt/administrator/land/land_owners?isPaginate=1',
    payload,
    callback
  );

export const getSingleLandOwner = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_LAND_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${id}`,
    payload,
    callback
  );

export const createLandOwner = (payload, callback) =>
  req.create(
    c.CREATE_LAND_OWNER,
    'api/v1/rpt/administrator/land/land_owners',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateLandOwner = (id, payload, callback) =>
  req.update(
    c.UPDATE_LAND_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeLandOwner = (id, payload, callback) =>
  req.remove(
    c.REMOVE_LAND_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const createCoOwner = (payload, callback) =>
  req.create(
    c.CREATE_CO_OWNER ,
    `api/v1/rpt/administrator/land/land_owners/${payload.ownerId}/land_co_owners`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateCoOwner = (payload, callback) =>
  req.update(
    c.UPDATE_CO_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${payload.rptax_land_owner_id}/land_co_owners/${payload.id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );


export const removeCoOwner = (payload, callback) =>
  req.remove(
    c.REMOVE_CO_OWNER,
    `api/v1/rpt/administrator/land/land_owners/${payload.rptax_land_owner_id}/land_co_owners/${payload.id}`,
    () => {
      if (callback) callback();
    }
  );

export const getOwnerProperties = (payload, callback) => 
  req.list(
    c.GET_OWNER_PROPERTIES,
    `api/v1/rpt/administrator/land/land_applications`,
    payload,
    callback
  );